module.exports = __webpack_public_path__ + "static/img/8-1.5698d2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/sky102/8-1.png
// module id = lo8w
// module chunks = 1